module.exports = __webpack_public_path__ + "img/app_logo.dc6d935e.svg";